"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const useClickOutsideHandler_1 = __importDefault(require("~/hooks/useClickOutsideHandler"));
const react_i18next_1 = require("react-i18next");
const UI_1 = require("~/components/UI");
const assets_1 = require("~/assets");
const BOMItemNotes_scss_1 = __importDefault(require("./BOMItemNotes.scss"));
const types_1 = require("./types");
function BOMItemNotes({ notes, show, updateNotesHandler, updateShow, y }) {
    const { t } = (0, react_i18next_1.useTranslation)('widgets');
    const [currentNotes, setCurrentNotes] = (0, react_1.useState)(notes || '');
    const [mode, setMode] = (0, react_1.useState)(notes ? types_1.NotesMode.View : types_1.NotesMode.Create);
    const wrapperRef = (0, react_1.useRef)(null);
    const elementRef = (0, react_1.useRef)(null);
    const hideContextMenu = () => {
        updateShow(false);
    };
    const resetNote = () => {
        setCurrentNotes(notes || '');
        setMode(notes ? types_1.NotesMode.View : types_1.NotesMode.Create);
        hideContextMenu();
    };
    (0, useClickOutsideHandler_1.default)(wrapperRef, elementRef, resetNote);
    const saveClickHandle = () => {
        setMode(currentNotes ? types_1.NotesMode.View : types_1.NotesMode.Create);
        if (currentNotes !== notes) {
            updateNotesHandler(currentNotes === '' ? null : currentNotes);
        }
        hideContextMenu();
    };
    const cancelClickHandle = () => {
        if (mode === types_1.NotesMode.Edit) {
            setCurrentNotes(notes || '');
            setMode(types_1.NotesMode.View);
        }
        else {
            resetNote();
        }
    };
    const deleteClickHandle = () => {
        setCurrentNotes('');
        setMode(types_1.NotesMode.Create);
        updateNotesHandler(null);
        hideContextMenu();
    };
    const editClickHandle = () => {
        setMode(types_1.NotesMode.Edit);
    };
    if (!show) {
        return null;
    }
    return (react_1.default.createElement("div", { ref: wrapperRef, className: BOMItemNotes_scss_1.default.container, style: {
            '--y': `${y ? y + 16 : 16}px`,
        } },
        react_1.default.createElement("div", { className: BOMItemNotes_scss_1.default.noteFrame },
            mode === types_1.NotesMode.Create && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: BOMItemNotes_scss_1.default.header },
                    react_1.default.createElement("div", null, t('item.add-note')),
                    react_1.default.createElement("div", { className: BOMItemNotes_scss_1.default.buttonsContainer },
                        react_1.default.createElement(UI_1.Button, { onClick: cancelClickHandle }, t('bom.cancel')),
                        react_1.default.createElement(UI_1.Button, { variant: "primary", onClick: saveClickHandle, disabled: currentNotes === '' }, t('bom.save')))),
                react_1.default.createElement("div", { className: BOMItemNotes_scss_1.default.createEditNotesContainer, ref: elementRef },
                    react_1.default.createElement(UI_1.Input, { type: "text", maxLength: 250, value: currentNotes, placeholder: t('bom.start-typing'), onInput: setCurrentNotes })))),
            mode !== types_1.NotesMode.Create && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: BOMItemNotes_scss_1.default.header },
                    mode === types_1.NotesMode.View && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", null, t('item.view-note')),
                        react_1.default.createElement("div", { className: BOMItemNotes_scss_1.default.buttonsContainer },
                            react_1.default.createElement("div", { style: { cursor: 'pointer' }, className: BOMItemNotes_scss_1.default.iconImg, onClick: editClickHandle },
                                react_1.default.createElement("img", { src: assets_1.svgBasicEdit, alt: "Icon edit" })),
                            react_1.default.createElement("div", { style: { cursor: 'pointer' }, className: BOMItemNotes_scss_1.default.iconImg, onClick: deleteClickHandle },
                                react_1.default.createElement("img", { src: assets_1.svgBasicDeleteIcon, alt: "Icon delete" }))))),
                    mode === types_1.NotesMode.Edit && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", null, t('item.edit-note')),
                        react_1.default.createElement("div", { className: BOMItemNotes_scss_1.default.buttonsContainer },
                            react_1.default.createElement(UI_1.Button, { onClick: cancelClickHandle }, t('bom.cancel')),
                            react_1.default.createElement(UI_1.Button, { variant: "primary", onClick: saveClickHandle }, t('bom.save')))))),
                mode === types_1.NotesMode.View && (react_1.default.createElement("div", { className: BOMItemNotes_scss_1.default.viewNotesContainer, ref: elementRef }, notes)),
                mode === types_1.NotesMode.Edit && (react_1.default.createElement("div", { className: BOMItemNotes_scss_1.default.createEditNotesContainer, ref: elementRef },
                    react_1.default.createElement(UI_1.Input, { type: "text", maxLength: 250, value: currentNotes, placeholder: t('bom.start-typing'), onInput: setCurrentNotes }))))))));
}
exports.default = BOMItemNotes;
